var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnCalories },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnCalories",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" + _vm._s(_vm.t("health", "Burned calories", {})) + "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnDuration },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnDuration",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Activity duration [minutes]", {})) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnCategory },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnCategory",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Category", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnFeeling },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnFeeling",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Feeling after the activity", {})) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnIntensity },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnIntensity",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Activity intensity", {})) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.activitiesColumnDistance },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "activitiesColumnDistance",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Distance", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v(_vm._s(_vm.t("health", "Unit for distance", {})))])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "text",
          value: _vm.person.activitiesDistanceUnit,
          icon: "icon-category-customization"
        },
        on: { submit: _vm.updateDistanceUnit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }